module.exports = __webpack_public_path__ + "static/media/YF53_6.dc91ab97.jpg";